/* ==========================================================================
   Messpunkte fuer die Test-Roadmap

   Sechs Ereignisse, ohne die H2 und H3 nicht auswertbar sind:

       kern_toggle_on        Bundle-Kasten auf der Produktseite angehakt
       quick_add_komplett    „Komplett" aus der Kollektion gelegt
       cart_upsell_kern      Kern-Fangnetz im Warenkorb angenommen
       cart_upsell_sticker   Sticker als Schwellenfueller angenommen
       versandfrei_erreicht  29-EUR-Grenze im Warenkorb erreicht
       checkout_step         zur Kasse gegangen

   WOHIN SIE GEHEN

   Zur Laufzeit gemessen: Auf der Storefront existiert HEUTE nur
   `Shopify.analytics.publish`. Kein gtag, kein dataLayer, kein fbq, kein
   Clarity, kein Hotjar. `publish` ist Shopifys eigener Ereignis-Bus; ein
   Custom Pixel im Admin meldet sich darauf an und leitet weiter, wohin man
   will — GA4, Meta, was spaeter dazukommt.

   Trotzdem werden vier Wege bedient. Nicht aus Unentschlossenheit: Sobald
   der Google- oder Meta-Kanal installiert wird, erscheinen `gtag` und `fbq`
   von selbst, und dann sollen die Ereignisse ohne weiteres Zutun dort
   ankommen. Ein Weg, den es nicht gibt, kostet einen `typeof`-Test.

   Zusaetzlich geht jedes Ereignis als DOM-Ereignis `md:ereignis` raus.
   Daran koennen sich Aufzeichnungswerkzeuge haengen, ohne dass jemand
   diese Datei anfassen muss.

   WARUM NICHT EINFACH IN mopeddruck.js

   Weil Messung und Verkaufslogik verschiedene Lebensdauern haben. Die
   Ereignisnamen stehen in der Roadmap und muessen dort nachschlagbar
   bleiben; die Verkaufslogik aendert sich mit jedem Test. Getrennt laesst
   sich das eine anfassen, ohne das andere zu gefaehrden.

   KEIN EREIGNIS DARF EINEN KLICK VERSCHLUCKEN

   Alles laeuft in `try`. Ein Messfehler darf niemals einen Kauf
   verhindern — das waere teurer als jede fehlende Zahl.
   ========================================================================== */
(function () {
  'use strict';

  var VORSATZ = 'md_';

  function senden(name, daten) {
    daten = daten || {};
    daten.quelle = 'theme';

    /* 1 — Shopifys Bus. Der einzige Weg, der heute existiert. */
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, daten);
      }
    } catch (e) { /* Messen darf nie stoeren */ }

    /* 2 — Google Tag Manager, falls spaeter installiert. */
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, daten));
      }
    } catch (e) { /* egal */ }

    /* 3 — GA4 unmittelbar, falls ohne Tag Manager eingebunden. */
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, daten);
    } catch (e) { /* egal */ }

    /* 4 — Meta. `trackCustom`, weil es keine Standardereignisse sind. */
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, daten);
    } catch (e) { /* egal */ }

    /* 5 — offen fuer alles Weitere. */
    try {
      document.dispatchEvent(new CustomEvent('md:ereignis', { detail: { name: name, daten: daten } }));
    } catch (e) { /* egal */ }
  }

  /* Manche Ereignisse koennen mehrfach ausgeloest werden, ohne dass sich
     etwas geaendert hat — der Warenkorb rendert sich bei jeder
     Mengenaenderung neu. `einmal` haelt einen Schluessel fest, damit aus
     einem Ereignis nicht zehn werden. */
  var gesehen = {};
  function einmal(schluessel, name, daten) {
    if (gesehen[schluessel]) return;
    gesehen[schluessel] = true;
    senden(name, daten);
  }
  function zuruecksetzen(praefix) {
    Object.keys(gesehen).forEach(function (k) {
      if (k.indexOf(praefix) === 0) delete gesehen[k];
    });
  }

  window.mdEreignis = senden;
  window.mdEreignisEinmal = einmal;

  /* ---- 1 Bundle-Kasten auf der Produktseite ---------------------------- */
  document.addEventListener('change', function (e) {
    var kasten = e.target && e.target.matches && e.target.matches('[data-md-bundle]') ? e.target : null;
    if (!kasten) return;
    /* Nur das Anhaken melden. Das Abwaehlen ist die Vorgabe rueckwaerts und
       wuerde die Zahlen verwaessern; wer es braucht, liest `kern_toggle_off`. */
    senden(VORSATZ + (kasten.checked ? 'kern_toggle_on' : 'kern_toggle_off'), {
      produkt: (document.querySelector('[data-md-pdp]') || {}).dataset
        ? (document.querySelector('[data-md-pdp]').dataset.mdProdukt || '')
        : ''
    });
  }, true);

  /* ---- 2/3/4 Quick-Add und Warenkorb-Upsells --------------------------- */
  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-md-quickadd]') : null;
    if (!knopf) return;

    /* Dieselbe Kennung traegt drei verschiedene Absichten. Unterschieden
       wird am Ort: in der Karte ist es der Quick-Add, im Warenkorb ein
       Upsell — und dort sagt der Text, welcher. */
    var imKorb = !!knopf.closest('.md-korb-extras');
    var name;
    if (!imKorb) {
      name = VORSATZ + 'quick_add_komplett';
    } else {
      name = /sticker/i.test(knopf.textContent || '')
        ? VORSATZ + 'cart_upsell_sticker'
        : VORSATZ + 'cart_upsell_kern';
    }

    senden(name, {
      variante: knopf.dataset.blattVariante || '',
      text: (knopf.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
    });
  }, true);

  /* ---- 5 Zur Kasse ----------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('[name="checkout"], #CartDrawer-Checkout') : null;
    if (!k) return;
    senden(VORSATZ + 'checkout_step', { ort: k.closest('cart-drawer') ? 'schublade' : 'warenkorbseite' });
  }, true);

  /* ---- 6 Versandfreigrenze erreicht ------------------------------------
     Es gibt kein Ereignis dafuer — der Warenkorb rendert sich neu, und der
     Balken traegt dann eine andere Klasse. Beobachtet wird deshalb das
     Markup. Der Schluessel enthaelt den Warenkorbwert, damit dasselbe
     Erreichen nicht bei jeder Neuzeichnung erneut zaehlt, ein spaeteres
     Unterschreiten und Wiedererreichen aber schon. */
  function balkenPruefen() {
    var voll = document.querySelector('.md-frei__fuellung--voll');
    if (!voll) {
      zuruecksetzen(VORSATZ + 'versandfrei');
      return;
    }
    var betrag = (document.querySelector('.md-frei__betrag') || {}).textContent || 'voll';
    einmal(VORSATZ + 'versandfrei:' + betrag, VORSATZ + 'versandfrei_erreicht', {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', balkenPruefen);
  } else {
    balkenPruefen();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(balkenPruefen).observe(document.body, { childList: true, subtree: true });
  }
})();
